import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) { }

  getCurrentAppVersion(body: any) {
    return this.http.post(this.baseUrl + 'Configuration/AppVersion/GetCurrentAppVersion', body);
  }

  loginUser(body: any) {
    return this.http.post(this.baseUrl + 'Profile/User/LoginUser', body)
  }

  verifyOtpToken(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Otp/VerifyOTPToken', body);
  }

  sendMobileOtp(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Otp/SendMobileOTPToken', body);
  }

  sendEmailOtp(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Otp/SendEmailOTPToken', body);
  }

  sendMobileAndEmailOtp(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Otp/SendMobileAndEmailOTPToken', body);
  }

  forgetPinRequest(body:any){
    return this.http.post(this.baseUrl + 'Profile/User/ForgetPinRequest', body);
  }

  createAppPin(body:any){
    return this.http.post(this.baseUrl + 'Profile/User/CreateAppPin', body);
  }

  logout(){
    return this.http.get(this.baseUrl+ 'Profile/User/LogoutUser');
  }
}
